// This file bundles utils that are commonly used
//  by pwa-modules but dont qualify for a separate file

import debounce from 'lodash.debounce';
import { act } from 'react-dom/test-utils';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

export { act, debounce };

/**
 * Sanitizes and parses a valid html string to corresponding react elements.
 * @param {string} htmlString The html string which needs to be parsed.
 *
 * @example
 * ```
 * <>
 *  {parseHtml('<div>Example</div>')}
 * </>
 * ```
 *
 */
export function parseHtml(htmlString) {
  return parse(DOMPurify.sanitize(htmlString));
}

/**
 * Sanitizes and parses a valid html string and returns a react component.
 * @param {string} htmlString The html string which needs to be parsed.
 *
 * @example
 * ```
 *  const ParsedComponent = useHtml('<div>Example</div>');
 *
 *  return (
 *    <>
 *      <ParsedComponent />
 *    </>
 *  );
 * ```
 */
export function useHtml(htmlString) {
  return () => parseHtml(htmlString);
}
